import { memo, useEffect } from 'react';
import noop from '@picsart/rc/noop';
import classNames from 'classnames';

import useClickOutside from 'hooks/common/useClickOutside';
import { isEscEvent } from 'utils/common/hotKeyCombinations';

import IModal, { ModalHorizontalPosition, ModalVerticalPosition } from './types';
import useStyles from './styles';

function Modal({
  children,
  zIndex,
  contentIsFullWidth = false,
  contentIsFullHeight = false,
  verticalPosition = ModalVerticalPosition.Middle,
  horizontalPosition = ModalHorizontalPosition.Center,
  // TODO-THEME
  backgroundColor = 'transparent',
  onClose = noop,
  className,
  classNameBackLayer,
}: IModal) {
  const styles = useStyles({
    zIndex, contentIsFullWidth, contentIsFullHeight, verticalPosition, horizontalPosition, backgroundColor,
  });

  const modalContentRef = useClickOutside(onClose);

  useEffect(() => {
    const keyPressed = (e: KeyboardEvent) => {
      if (isEscEvent(e)) {
        onClose(e);
      }
    };

    window.addEventListener('keydown', keyPressed);

    return () => {
      window.removeEventListener('keydown', keyPressed);
    };
  });

  return (
    <div className={classNames(styles.root, className)} data-testid="modal">
      <div className={classNames(styles.backLayer, classNameBackLayer)} />
      <div className={styles.container}>
        <div className={styles.row}>
          <div className={styles.cell}>
            <div className={styles.content} ref={modalContentRef}>{children}</div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default memo(Modal);
